import { Controller } from "@hotwired/stimulus"

// Live character counter for custom report text fields. Shows the current length
// (and the maximum when one is configured) below the input, turning red when the
// value falls outside the configured min/max bounds.
export default class extends Controller {
  static targets = ["input", "count"]
  static values = { min: Number, max: Number }

  connect() {
    this.update()
  }

  update() {
    const length = this.inputTarget.value.length
    this.countTarget.textContent = this.hasMaxValue ? `${length} / ${this.maxValue}` : `${length}`

    const tooLong = this.hasMaxValue && length > this.maxValue
    const tooShort = this.hasMinValue && length > 0 && length < this.minValue
    this.countTarget.classList.toggle("text-red-500", tooLong || tooShort)
  }
}
